// Endereço da API — fonte única.
//
// A API roda na MESMA máquina que serve este front, na porta 5070. Então o
// navegador deve chamá-la no mesmo host que usou para abrir a página: quem abre
// em localhost fala com localhost; quem abre em 192.168.0.20 (outro dev na mesma
// rede) fala com 192.168.0.20.
//
// Antes o valor era `http://localhost:5070/api` fixo, repetido em três arquivos.
// Como ele vai embutido no bundle que roda NO NAVEGADOR, para qualquer pessoa
// que não fosse o dono da máquina "localhost" apontava para o computador dela —
// que não tem API. O login falhava e o dashboard não abria.
//
// NEXT_PUBLIC_API_URL continua tendo prioridade, para quando a API estiver em
// outro host (deploy, nuvem).
export function apiBaseUrl(): string {
  const configurada = process.env.NEXT_PUBLIC_API_URL;
  if (configurada) return configurada;

  // Sem window é SSR: o servidor chamando a si mesmo.
  if (typeof window === 'undefined') return 'http://localhost:5070/api';

  return `${window.location.protocol}//${window.location.hostname}:5070/api`;
}
